import store from '@/store'
import { OptionList, getRMBRate } from '@/api/common'
import { fetchTenantDetail } from '@/api/tenant/tenantManage'
import { hasPhoneCodeValid } from "@/api/users";
import { formatResOption } from '@/utils/tools'
import { VuexModule, Module, getModule, Mutation, Action } from 'vuex-module-decorators'
import { UserModule } from '@/store/modules/user'

export interface CommonState {
  nationData: object[];
  regionData: object[];
  occupationData: object[];
  curencyData: object[];
  customerId: string;
  customerName: string;
  tenantDetail: string[];
}

export interface OptionInterface {
  type: string;
  data: [];
}

const seImgSource = JSON.parse(sessionStorage.getItem('imgSource') as string)
const seTenantConfig = JSON.parse(sessionStorage.getItem('tenantConfig') as string)
@Module({ name: 'common', dynamic: true, store })
class Common extends VuexModule implements CommonState {
  public customerId = sessionStorage.getItem('customerId') || ''
  public customerName = sessionStorage.getItem('customerName') || ''
  public nationData: object[] = []
  public regionData: object[] = []
  public occupationData: object[] = []
  public curencyData: object[] = []
  public rmbDollarRate = 0
  customerInfo = sessionStorage.getItem('customerInfo') ? JSON.parse(sessionStorage.getItem('customerInfo') as string) : { age: 0, gender: 0 }
  public imgSource = seImgSource && Object.keys(seImgSource).length > 0 ? seImgSource : {
    logo: '',
    cornerMark: '',
    cover: '',
    backCover: '',
    assetAllocationSuggest: '',
    invest: '',
    pension: '',
    family: '',
    children: '',
    slogan: '',
    compliance: '',
    storyLineOrg: false
  }
  public tenantConfig = seTenantConfig && Object.keys(seTenantConfig).length > 0 ? seTenantConfig : {}

  public tenantDetail: string[] = sessionStorage.getItem('tenantDetail') ? JSON.parse(sessionStorage.getItem('tenantDetail') as string) : []

  @Mutation SET_USER_NAME(v: string) {
    this.customerName = v
    window.sessionStorage.setItem('customerName', v)
  }

  @Mutation SET_USER_GENDER(v: string) {
    this.customerInfo.gender = v
    window.sessionStorage.setItem('gender', v)
  }



  @Mutation SET_RDRate(v: number) {
    this.rmbDollarRate = v
  }

  @Mutation SET_IMG_SOURCE(v: any) {
    console.log('step1 - 3')
    console.log('SET_IMG_SOURCE', v)
    this.imgSource = v
    sessionStorage.setItem('imgSource', JSON.stringify(v))
  }

  @Mutation SET_TENANT_CONFIG(v: any) {
    this.tenantConfig = v
    sessionStorage.setItem("tenantConfig", JSON.stringify(v))
  }

  @Mutation SET_CUSTOMERID(v: any) {
    this.customerId = v.id
    this.customerName = v.customerName
    sessionStorage.setItem('customerId', v.id)
    sessionStorage.setItem('customerName', v.customerName)
    sessionStorage.setItem('customerInfo', JSON.stringify(v))
    this.customerInfo = v
  }

  @Mutation SET_CUSTOMERID_VAl(v: any) {
    this.customerId = v
    sessionStorage.setItem('customerId', v)
  }

  @Mutation
  private SET_OPTION({ type, data }: OptionInterface) {
    if (type === 'Nation') {
      this.nationData = data
    }
    if (type === 'Region') {
      this.regionData = data
    }
    if (type === 'Occupation') {
      this.occupationData = data
    }
    if (type === 'Currency') {
      this.curencyData = formatResOption(data)
    }
  }

  @Action
  public async getRMBRateAction() {
    const res = await getRMBRate()
    if (res.data) { this.SET_RDRate(res.data) }
  }

  @Action
  public getImgSourceAction() {
    console.log('step1- 4 UserModule.tenantId', UserModule.tenantId)
    return new Promise(async (resolve, reject) => {
      if (UserModule.tenantId) {
        const res = await fetchTenantDetail({
          tenantId: UserModule.tenantId
        })
        if (res.data && res.statusCode === 0) {
          this.SET_IMG_SOURCE(res.data)
        }
      }
      resolve(true)
    })

  }

  @Action
  public getTenantConfigAction() {
    return new Promise(async (resolve, reject) => {
      const res = await hasPhoneCodeValid();
      if (res.data && res.statusCode === 0) {
        this.SET_TENANT_CONFIG(res.data)
      }
      resolve(true)
    })

  }


  @Action
  public async LibraryAction() {
    const resArr = await Promise.all([
      // OptionList({ dicType: 'Nation' }),
      // OptionList({ dicType: 'Region' }),
      // OptionList({ dicType: 'Occupation' }),
      OptionList({ dicType: 'Currency' })
    ])
    if (resArr[0].statusCode === 0) {
      const { data } = resArr[0]
      this.SET_OPTION({ type: 'Currency', data })
    }

    // if (resArr[1].statusCode === 0) {
    //   const { data } = resArr[1]
    //   this.SET_OPTION({ type: 'Region', data })
    // }

    // if (resArr[2].statusCode === 0) {
    //   const { data } = resArr[2]
    //   this.SET_OPTION({ type: 'Occupation', data })
    // }

    // if (resArr[3].statusCode === 0) {
    //   const { data } = resArr[3]
    //   this.SET_OPTION({ type: 'Currency', data })
    // }
  }
}

export const CommonMudule = getModule(Common)
